import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import FounderStory from './components/FounderStory';
import Timeline from './components/Timeline';
import IngredientPhilosophy from './components/IngredientPhilosophy';
import CommunityImpact from './components/CommunityImpact';
import Certifications from './components/Certifications';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="main-content">
        <HeroSection />
        <FounderStory />
        <Timeline />
        <IngredientPhilosophy />
        <CommunityImpact />
        <Certifications />
        <Testimonials />
        <CallToAction />
      </main>

      <Footer />
    </div>
  );
};

export default About;